import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import DraftItem from "./DraftItem";
const DraftsList = ({ drafts = [], activeTab, onResume, onDelete }) => {
    console.log('[DraftsList] Rendering with:', {
        draftsCount: drafts.length,
        activeTab,
        hasOnDelete: !!onDelete
    });
    if (drafts.length === 0) {
        return (_jsxs("div", { className: "flex items-center justify-center py-12 text-gray-500 text-[13px]", children: ["No ", activeTab, " found"] }));
    }
    return (_jsx("div", { className: "grid grid-cols-2 gap-4 self-stretch", children: drafts.map((draft) => (_jsx(DraftItem, { title: draft.title, slideCount: draft.slideCount, fileName: draft.fileName, isNew: draft.isNew, dateLabel: draft.dateLabel, onClick: () => onResume?.(draft.id), onDelete: onDelete ? () => {
                console.log('[DraftsList] Delete triggered for plan:', draft.id);
                onDelete(draft.id);
            } : undefined }, draft.id))) }));
};
export default DraftsList;
